import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: true,
  currentPage: 1,
  searchTerm: "",
  searchResults: [],
  totalSearch: 1,
  facets: [],
  topics: [],
  categories: [],
  price: [],
  err: {},
  pageSize: 25,
  isError: false,
  sortBy: "",
  query: ""
};

var articleReducer = function articleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.SORT_BY_CHANGE:
      {
        var sortBy = action.sortBy;
        return _objectSpread(_objectSpread({}, state), {}, {
          sortBy: sortBy
        });
      }

    case Types.PAGE_CHANGE:
      {
        var currentPage = action.currentPage;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentPage: currentPage
        });
      }

    case Types.PAGE_SIZE_CHANGE:
      {
        var pageSize = action.pageSize;
        return _objectSpread(_objectSpread({}, state), {}, {
          pageSize: pageSize
        });
      }

    case Types.TERM_CHANGE:
      {
        var searchTerm = action.searchTerm;
        var page = state.currentPage;
        var query = state.query;

        if (searchTerm !== state.query) {
          query = searchTerm;
          page = 0;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          searchTerm: searchTerm,
          currentPage: page,
          query: query
        });
      }

    case Types.DATA_SOURCE_CHANGE:
      {
        var dataSource = action.dataSource;
        return _objectSpread(_objectSpread({}, state), {}, {
          dataSource: dataSource
        });
      }

    case Types.TOPICS_CHANGE:
      {
        var topics = action.topics,
            _currentPage = action.currentPage;
        return _objectSpread(_objectSpread({}, state), {}, {
          topics: topics,
          currentPage: _currentPage
        });
      }

    case Types.CATEGORIES_CHANGE:
      {
        var categories = action.categories,
            _currentPage2 = action.currentPage;
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: categories,
          currentPage: _currentPage2
        });
      }

    case Types.PRICE_CHANGE:
      {
        var price = action.price,
            _currentPage3 = action.currentPage;
        return _objectSpread(_objectSpread({}, state), {}, {
          price: price,
          currentPage: _currentPage3
        });
      }

    case Types.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.RESPONSE:
      {
        var searchResults = action.searchResults,
            totalSearch = action.totalSearch,
            facets = action.facets;
        return _objectSpread(_objectSpread({}, state), {}, {
          searchResults: searchResults,
          totalSearch: totalSearch,
          facets: facets,
          isLoading: false
        });
      }

    case Types.CLEAR_RAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          categories: [],
          topics: [],
          price: []
        });
      }

    default:
      {
        return state;
      }
  }
};

export default articleReducer;